import * as React from 'react'
import { connect } from 'react-redux'
import { actions } from 'react-redux-form'

import { SRPRS } from 'components/_Assets/svg/Icon/srprs'
import { ActionList } from 'components/ActionList'
import Box, { BoxType } from 'components/Box'
import { Button, TYPE } from 'components/Button'
import Heading from 'components/Heading'
import Hero from 'components/Hero'
import { HeroType } from 'components/Hero/Hero'
import { InfoBox, InfoBoxItem } from 'components/InfoBox/InfoBox'
import ListHeader from 'components/ListHeader'
import Section, { SectionType, Size } from 'components/Section/Section'
import Style from 'components/Style'
import { getCdnUrl } from '../../data/api/cdn'
import { EntryProps } from '../../data/entries/types'
import { City } from '../../data/models/funnelOrder/cities'
import { trainOptions } from '../../data/models/funnelOrder/days'
import { destinationEnum } from '../../data/models/funnelOrder/destination'
import { roomType } from '../../data/models/funnelOrder/roomType'
import { SiteCountry, SiteCurrency } from '../../data/models/locale'
import { AppState } from '../../data/state'
import { FunnelStep } from '../../data/ui'
import Calendar from '../../elements/Calendar'
import FunnelFooter from '../../elements/footers/funnelFooter'
import FunnelBreadcrumbs from '../../elements/FunnelBreadcrumbs'
import GiftcardModal from '../../elements/modals/GiftcardModal'
import PersonModal from '../../elements/modals/PersonModal'
import { getNameWithTheme, getParamsWithTheme } from '../../routing/links'
import Days from '../funnel/customise/options/days'
import People from '../funnel/customise/options/people'
import TrainExcluded from '../funnel/customise/options/trainExcluded'
import { QueryKey } from '../funnel/customise/wrapper'
import {
  CustomiseWrapperInnerProps,
  withAirportsAndPrices,
} from '../funnel/customise/wrapperFunction'
import DisplayContent from '../shared/content'
import Page from '../shared/page_wrapper'
import BasicInfo from './components/basicInfo'
import HowItWorks from './components/entries/howItWorks'
import FAQ from './components/faq'
import FlavourBox from './components/flavourBox'

interface TrainProps extends EntryProps {
  destination: destinationEnum
  total: number
  patternImage: string
  roomtype: number
  country: SiteCountry
  currency: SiteCurrency
  excludedCities: City[]
  setExcludedCities(cities: City[]): void
  setRoomType(theRoomType: roomType): void
  setYearAndMonth(year: number, month: number): void
}

class TrainPage extends React.Component<
  TrainProps & CustomiseWrapperInnerProps
> {
  private infoSection?: HTMLDivElement
  private detailsSection?: HTMLDivElement
  private timer?: NodeJS.Timeout | any

  public componentDidMount() {
    const hash = window.location.hash
    if (hash !== undefined && hash === '#steden') {
      this.timer = setTimeout(() => {
        if (this.detailsSection) {
          this.detailsSection.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
          })
        }
      }, 2000)
    } else {
      window.scrollTo(0, 0)
    }
  }

  public componentWillUnmount() {
    clearTimeout(this.timer)
  }

  public render() {
    const { country, entry, match, prices, loading, patternImage } = this.props

    if (entry.page === undefined) {
      throw new Error('No page properties')
    }

    let countrySlug = ''
    switch (country) {
      case SiteCountry.uk:
        countrySlug = '-uk'
        break
      case SiteCountry.ie:
        countrySlug = '-ie'
        break
    }
    return (
      <Page
        match={match}
        page={entry.page.name}
        color={entry.colour}
        navBarType="funnel"
        navBarOverrideColour={
          entry.page.style ? entry.page.style.navbarColor : undefined
        }
        navFooter
      >
        <Hero
          blurMobile
          type={HeroType.flavourEntry}
          headingColor={
            entry.page.style ? entry.page.style.headingColor : undefined
          }
          headingText={
            <DisplayContent contentKey="title">{entry.name}</DisplayContent>
          }
          subHeading={<FunnelBreadcrumbs funnelStep={FunnelStep.Customise} />}
          src={entry.page.photos.src}
          src768={entry.page.photos.src768}
          src1024={entry.page.photos.src1024}
          src1280={entry.page.photos.src1280}
          src1600={entry.page.photos.src1600}
          src1920={entry.page.photos.src1920}
        >
          <FunnelBreadcrumbs funnelStep={FunnelStep.Customise} />
          <Heading level={1}>
            <DisplayContent contentKey="title">{entry.name}</DisplayContent>
          </Heading>
          <InfoBox>
            <InfoBoxItem
              icon={SRPRS.calendarColored()}
              firstLine={
                <DisplayContent contentKey={`1-info-top${countrySlug}`}>
                  3 Dagen
                </DisplayContent>
              }
            />
            <InfoBoxItem
              icon={SRPRS.bedColored}
              iconProps={{
                width: '44',
                height: '33',
                viewBox: '0 0 44 33',
                fill: 'none',
              }}
              firstLine={
                <DisplayContent contentKey="2-info-top">
                  hotel of
                </DisplayContent>
              }
              secondLine={
                <DisplayContent contentKey="2-info-bottom">
                  hostel
                </DisplayContent>
              }
            />
            <InfoBoxItem
              icon={SRPRS.mapMarkerColored}
              iconProps={{
                width: '41',
                height: '37',
                viewBox: '0 0 37 41',
                fill: 'none',
              }}
              firstLine={
                <DisplayContent contentKey="3-info-top">Heel</DisplayContent>
              }
              secondLine={
                <DisplayContent contentKey="3-info-bottom">
                  Europa
                </DisplayContent>
              }
            />
          </InfoBox>
        </Hero>
        <BasicInfo
          detailsScroll={this.handleDetailsScroll}
          infoScroll={this.handleInfoScroll}
          contentKeySlug={countrySlug}
          nrItems={4}
        />
        <Section type={SectionType.solid} size={Size.xs}>
          <Style margin={[[0, 0, 20, 0]]}>
            <div ref={this.setDetailsRef} />
            <div className="margin-b-m">
              <ActionList>
                <People />
                <Days options={trainOptions} />
                <TrainExcluded />
              </ActionList>
            </div>
            <Box fullWidthMobile>
              <Calendar
                actionList
                hideTrigger
                showCheapest={true}
                prices={prices}
                loading={loading}
              />
            </Box>
          </Style>
          <PersonModal />
        </Section>
        <FunnelFooter
          nextStepNo={2}
          nextStepLink={getNameWithTheme('extras')}
          nextStepLinkParams={getParamsWithTheme()}
          nextStepName={
            <DisplayContent edit={true} contentKey="extras">
              Extras
            </DisplayContent>
          }
          stickyStop
          nextStepDisabled={isNaN(this.props.total)}
        />
        <GiftcardModal />
        <FlavourBox
          patternImage={patternImage}
          setInfoRef={this.setInfoRef}
          content={entry.page.content}
        />
        <HowItWorks boxTypeColor={BoxType.shalimar} />
        <Section type={SectionType.white}>
          <ListHeader noMarginBottom>
            <Button
              cutOff="none"
              type={TYPE.plain}
              onClick={this.handleDetailsScroll}
            >
              <DisplayContent contentKey="boek-direct" edit={true}>
                Boek direct
              </DisplayContent>
            </Button>
          </ListHeader>
        </Section>
        <FAQ nrItems={5} />
      </Page>
    )
  }

  private changeRoomType = (roomtype: string) => {
    this.props.setRoomType(+roomtype)
  }

  private setInfoRef = (ref: HTMLDivElement) => {
    this.infoSection = ref
  }

  private setDetailsRef = (ref: HTMLDivElement) => {
    this.detailsSection = ref
  }

  private handleInfoScroll = () => {
    if (this.infoSection) {
      this.infoSection.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }
  }

  private handleDetailsScroll = () => {
    if (this.detailsSection) {
      this.detailsSection.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }
  }
}

const ConnectedTrainPage = connect(
  (state: AppState) => ({
    destination: state.funnelOrder.destination,
    patternImage: state.page.patternImage,
    total: state.funnelOrder.total,
    roomtype: state.funnelOrder.roomType,
    country: state.locale.country,
    currency: state.locale.currency,
    excludedCities: state.funnelOrder.excludedCitiesIds,
  }),
  dispatch => ({
    setExcludedCities: (cities: City[]) => {
      dispatch(actions.change('funnelOrder.excludedCitiesIds', cities))
    },
    setRoomType: (theRoomType: roomType) => {
      dispatch(actions.change('funnelOrder.roomType', theRoomType))
    },
    setYearAndMonth: (year: number, month: number) => {
      dispatch(actions.change('funnelOrder.year', year))
      dispatch(actions.change('funnelOrder.month', month))
    },
  }),
)(TrainPage)

export default withAirportsAndPrices<EntryProps>(
  ConnectedTrainPage,
  [QueryKey.numberOfDays, QueryKey.month, QueryKey.year],
  false,
  true,
)
